
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Gift from "@/components/common/Gift.vue"
import CartButton from "@/components/products/framepuzzle/util/CartButton.vue"
import { FramePuzzleModule } from "@/store/modules/framePuzzle"

@Component({
    name: "gift",
    components: {
        CartButton
    }
})
export default class GiftImpl extends Gift {
    private giftOptionValue = false

    giftOptionChanged(): void {
        FramePuzzleModule.SetGiftOption(this.giftOptionValue)
    }
}
